const en_US = {
  refresh_tip: 'When the refresh interval is less than step({{num}}s), the data will not be updated',
};
export default en_US;
